import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import { PACKAGE_TYPE } from '../../../../../utilities/constants';
import { SummaryModal } from '../../Modal';
import * as COPY from './utilities/copy';

import { useEffect } from 'react';
import { Content } from './Content';

const propTypes = {
  /** Flag to indicate if the summary is visible or not */
  opened: PropTypes.bool,
  /** Function that executes when click on the Close Button */
  onClose: PropTypes.func
};

export const Summary = ({ opened, onClose, ...restProps }) => {
  const { search } = useLocation();
  const { isPackagesUpdated, addLCOSuccess } = restProps;

  useEffect(() => {
    const { pck } = queryString.parse(search);
    if (isPackagesUpdated !== null && isPackagesUpdated?.includes(PACKAGE_TYPE.lateCheckOut)) {
      addLCOSuccess(pck);
    }
  }, [search, isPackagesUpdated, addLCOSuccess]);

  return (
    <SummaryModal opened={opened} onRequestClose={onClose}>
      <SummaryModal.Header>
        <SummaryModal.Title lineHeight={24}>{COPY.SUMMARY_TITLE}</SummaryModal.Title>
        <SummaryModal.CloseButton onClick={onClose} />
      </SummaryModal.Header>
      <SummaryModal.Content>
        <Content {...restProps} />
      </SummaryModal.Content>
    </SummaryModal>
  );
};

Summary.propTypes = propTypes;
Summary.defaultProps = {
  opened: false
};
